import { render, staticRenderFns } from "./PortalRfxWrapper.vue?vue&type=template&id=6a301993"
import script from "./PortalRfxWrapper.vue?vue&type=script&lang=js"
export * from "./PortalRfxWrapper.vue?vue&type=script&lang=js"
import style0 from "./PortalRfxWrapper.vue?vue&type=style&index=0&id=6a301993&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports